<template>
  <div class="edit" v-drag>
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header" >
          <span class="modal-title">{{head_title}}</span>
          <span aria-hidden="true" class="modal-span" @click="close">&times;</span> 
        </div>
        <div class="modal-body">
          <input type="text" style="opacity:0;">
          <div class="form-group">
            <label for="exampleInputPassword1">{{new_password}}</label>
            <input type="password" class="form-control"  placeholder="Password" v-model="new_pas">
          </div>
          <div class="form-group">
            <label for="exampleInputPassword1">{{repeat_password}}</label>
            <input type="password" class="form-control"  placeholder="Password" v-model="repeat_pas">
          </div>
        </div>
        <!-- 弹框 -->
        <div class="box_data" v-if="box_shows">
          <p>{{input_result}}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default btn-default-close" data-dismiss="modal" @click="cancel">{{cancel}}</button>
          <button type="button" class="btn btn-default-determine" @click="confirm">{{confirm}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name:'edit',
  data () {
    return {
       //新改密码
       new_pas:'',
       //重复密码
       repeat_pas:'',
       //弹框数据
       box_shows:false
    }
  },
  computed:{
    confirm(){
      return this.$attrs.language_pack[this.sel_language].confirm
    },
    cancel(){
      return this.$attrs.language_pack[this.sel_language].cancel
    },
    input_result(){
      return this.$attrs.language_pack[this.sel_language].input_result
    },
    repeat_password(){
      return this.$attrs.language_pack[this.sel_language].repeat_password
    },
    new_password(){
      return this.$attrs.language_pack[this.sel_language].new_password
    },
    head_title(){
        return '--'+this.$attrs.language_pack[this.sel_language].new_password+'--'
    },
    ...mapState({
        sel_language:'sel_language'
    })
  },
  mounted () {

  },
  methods: {
    //   确认按钮
    confirm(){
      if(this.new_pas==this.repeat_pas){
        this.$emit('pas_confirm',this.md(this.new_pas))
      }else{
        this.box_shows=true;
        setTimeout(()=>{
            this.box_shows=false;
        },2000)  
      }        
    },
    // 关闭图标
    close(){
      this.$emit('close_project')
    },
    // 取消按钮
    cancel(){
      this.new_pas='';
      this.repeat_pas='';
    }
  },
  components: {
     
  },
    directives: {
            drag: {inserted(el) {
                let drag_Box = el; //获取当前元素
                let dragBox = document.getElementsByClassName('modal-header')[0];
                dragBox.onmousedown = e => {
                    //算出鼠标相对元素的位置
                    let disX = e.clientX - drag_Box.offsetLeft;
                    let disY = e.clientY - drag_Box.offsetTop;
                    document.onmousemove = e => {
                        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                        let left = e.clientX - disX;
                        let top = e.clientY - disY;
                        //移动当前元素
                        drag_Box.style.left = left + "px";
                        drag_Box.style.top = top + "px";
                    };
                    document.onmouseup = e => {
                          //鼠标弹起来的时候不再移动
                          document.onmousemove = null;
                         //预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）  
                        document.onmouseup = null;
                    };
                };
            }
        }
    }
}
</script>
<style scoped>
  .modal-header{
    cursor: move;
  }
  .modal-body{
    position: relative;
    font-size: 14px;
  }
  .box_data{
    font-size: 14px;
    color: #fff;
    position: absolute;
    top: 40%;
    left: 40%;
    background: #5f5f5f;
    height: 50px;
    line-height: 50px;
    padding:0 20px;
    opacity: .7;
  }
  .edit{
    position: fixed;
    top: 50%;
    left: 50%;
    z-index:999;
    /* transform: translate(-50%, -50%); */
    overflow: visible;
	  bottom: inherit;
	  right: inherit;
	  transform: translate(calc(-50% + 0.5px), calc(-50% + 0.5px));
  }
  .text{
    margin: 0 auto;
    display: block;
    outline: none;
  }
  .modal-header{
	  background:#ebecf0;
	  height:40px
	}
  .modal-span{
	  font-size:20px;
	  margin-top:-14px;
	  cursor:pointer
	}
  .modal-title{
	  line-height:1px
	}
  .btn-default-close{
    color:#007bff;
	  font-size:12px;
	  border:1px solid #808080;
	  padding:4px;
	  /* margin-right: 393px; */
    }
  .modal-footer{
    justify-content: space-between;
    width: 500px;
  }
  .btn-default-determine{
    color:#007bff;
	  font-size:12px;
	  border: 1px solid rgb(128, 128, 128);
	  padding: 4px;
    }
</style>